import {
  FormSettingAttributes,
  GetFormSettingQuery,
  GetFormSettingQueryVariables,
  UpdateFormSettingMutation,
  UpdateFormSettingMutationVariables,
} from '@/typings/domain'
import apolloClient from './apolloClient'
import GetFormSettingGQL from './graphql/GetFormSetting.graphql'
import UpdateFormSettingGQL from './graphql/UpdateFormSetting.graphql'

export function getFormSetting({ formToken }: { formToken: string }) {
  return apolloClient.query<GetFormSettingQuery, GetFormSettingQueryVariables>({
    query: GetFormSettingGQL,
    variables: { formToken },
    fetchPolicy: 'no-cache',
  })
}

export function updateFormSetting({ formToken, attributes }: { formToken: string; attributes: FormSettingAttributes }) {
  return apolloClient.mutate<UpdateFormSettingMutation, UpdateFormSettingMutationVariables>({
    mutation: UpdateFormSettingGQL,
    variables: { formId: formToken, attributes },
    fetchPolicy: 'no-cache',
  })
}
